// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"138":"profile","187":"search","459":"edit-profile","535":"author-books","716":"manage-catalog"}[chunkId] || chunkId) + "." + {"138":"63cabe61","187":"080feb8c","342":"5c2c34f1","459":"36e445b4","535":"3bae0664","716":"140747bd","734":"87d4b4f1"}[chunkId] + ".js";
};